<!-- DatabaseIdType.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { DatabaseIdTypes } from '../Enums/ChoiceEnums';
    import { DisplayStyle, IconTypes } from '../Enums/UiEnums';
    import { DatabaseIdTypeNameAlias, iconType, aliasName } from '../lib/Formatting/DatabaseIdTypeInfo';
    import Icon from '../components/Icon.vue'

    const props = defineProps<{
        idType: DatabaseIdTypes,
        aliasType?: DatabaseIdTypeNameAlias,
        iconClass?: string
    }>();

    const idIconType = computed<IconTypes|undefined>(()=>{
        return iconType(props.idType);
    });

</script>

<template>
    <Icon v-if="idIconType" :icon="idIconType" :display="DisplayStyle.Primary"/>
    {{ aliasName(props.idType, props.aliasType ?? DatabaseIdTypeNameAlias.commonName) }}
</template>